<template>
  <div>
    <contracted-journeys-list />
  </div>
</template>

<script>
import ContractedJourneysList from "@/components/ContractedJourneys/list.vue";

export default {
  components: { ContractedJourneysList },
};
</script>
